import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import Typography from "@material-ui/core/Typography"
import Breadcrumbs from "@material-ui/core/Breadcrumbs"
import Link from "@material-ui/core/Link"
import NavigateNextIcon from "@material-ui/icons/NavigateNext"
import PropTypes from "prop-types"
import { useDispatch } from "react-redux"
import { push } from "redux-first-history"

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: theme.spacing(1),
  },
  link: {
    color: "black",
    opacity: 0.6,
    fontSize: 12,
  },
  typo: {
    color: "black",
    opacity: 0.87,
    fontSize: 12,
  },
}))

const SimpleBreadcrumbs = ({ previous = [], current = "" }) => {
  const classes = useStyles()
  const dispatch = useDispatch()

  const handleClick = (to) => (event) => {
    event.preventDefault()
    dispatch(push(to))
  }

  return (
    <Breadcrumbs
      className={classes.root}
      separator={<NavigateNextIcon className={classes.link} />}
      aria-label="breadcrumb"
    >
      {previous.map(({ href, name }, index) => (
        <Link
          key={index}
          href={href}
          className={classes.link}
          onClick={handleClick(href)}
        >
          {name}
        </Link>
      ))}

      <Typography className={classes.typo}>{current}</Typography>
    </Breadcrumbs>
  )
}

SimpleBreadcrumbs.propTypes = {
  previous: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })
  ),
  current: PropTypes.string.isRequired,
}

export default SimpleBreadcrumbs
